var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "auto",
                  },
                },
                [
                  _c("h4", [_vm._v("商品信息")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品图片：" } },
                    [
                      _c("upload", {
                        attrs: { ratio: "1:1" },
                        model: {
                          value: _vm.form.img_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "img_url", $$v)
                          },
                          expression: "form.img_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "product_name",
                      attrs: { label: "商品标题：", prop: "product_name" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写商品标题" },
                        model: {
                          value: _vm.form.product_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "product_name", $$v)
                          },
                          expression: "form.product_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "product_title",
                      attrs: { label: "副标题：", prop: "product_title" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写副标题" },
                        model: {
                          value: _vm.form.product_title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "product_title", $$v)
                          },
                          expression: "form.product_title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "cost_price",
                      attrs: { label: "成本价：", prop: "cost_price" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写成本价" },
                        model: {
                          value: _vm.form.cost_price,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cost_price", $$v)
                          },
                          expression: "form.cost_price",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "market_price",
                      attrs: { label: "零售价：", prop: "market_price" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写零售价" },
                        model: {
                          value: _vm.form.market_price,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "market_price", $$v)
                          },
                          expression: "form.market_price",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "stock_count",
                      attrs: { label: "库存：", prop: "stock_count" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写库存" },
                        model: {
                          value: _vm.form.stock_count,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "stock_count", $$v)
                          },
                          expression: "form.stock_count",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "已售：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "虚假的已售数量" },
                        model: {
                          value: _vm.form.sold_count,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sold_count", $$v)
                          },
                          expression: "form.sold_count",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态:" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-value": 1, "inactive-value": 0 },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v("注：开启表示上架，设备可关联此商品。"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品详情：" } },
                    [
                      _c("tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.form.product_introduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "product_introduce", $$v)
                          },
                          expression: "form.product_introduce",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mt-10 mb-10",
                          attrs: { type: "primary", disabled: _vm.clickSubmit },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("立即提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }